module.exports = __webpack_public_path__ + "img/ori_img_2.e9a4320a.png";